import "./index.scss"
import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

/**
 * Returns Item Layout
 */
export default function ResourceCard({ postData }) {
  const {
    title,
    slug,
    thematicTags,
    featuredImage,
    typeOfResource,
    reportSubtitle,
  } = postData

  const tags = thematicTags.split(", ")
  const img = getImage(featuredImage)

  return (
    <div className="col-md-6">
      <Link to={`/resources/${slug}`}>
        <div className="card flex-row">
          {featuredImage && (
            <div className="card__image">
              <GatsbyImage image={img} alt="" />
            </div>
          )}

          <div className="card__data" style={{ backgroundColor: "#18988B" }}>
            <div className="card__tags">
              {/* {
                tags?.map(tag => <span className="card__tag">{tag}</span>)
              } */}
              <span className="card__tag">
                {typeOfResource.replaceAll("-", " ")}
              </span>
            </div>

            <h5 className="card__title text-white">{title}</h5>

            <p className="card__content">{reportSubtitle}</p>
            <Link to={`/resources/${slug}`}>Read More</Link>
          </div>
        </div>
      </Link>
    </div>
  )
}
